import { NgModule } from '@angular/core';
import { GenesysCloudUsersModule } from './users/genesys-cloud-users.module';
import { GenesysCloudPresenceModule } from './presence/genesys-cloud-presence.module';
import { GenesysCloudNotificationsModule } from './notifications/genesys-cloud-notifications.module';
import { GenesysCloudConversationsModule } from './conversations/genesys-cloud-conversations.module';
import { GenesysCloudExternalContactsModule } from './external-contacts/genesys-cloud-external-contacts.module';
import { GenesysCloudDesktopNotificationsModule } from './desktop-notifications/genesys-cloud-desktop-notifications.module';
import { GenesysCloudWorkItemIntegrationsModule } from './work-item-integrations/genesys-cloud-work-item-integrations.module';
import { GenesysCloudRoutingStatusModule } from './routing-status/genesys-cloud-routing-status.module';
import { GenesysCloudIntegrationsModule } from './integrations/genesys-cloud-integrations.module';
import { GenesysCloudFeatureTogglesModule } from 'common/store/genesys-cloud/feature-toggles/genesys-cloud-feature-toggles.module';
import { GenesysCloudCobrowseModule } from './cobrowse/genesys-cobrowse.module';

@NgModule({
  imports: [
    GenesysCloudUsersModule,
    GenesysCloudPresenceModule,
    GenesysCloudNotificationsModule,
    GenesysCloudConversationsModule,
    GenesysCloudExternalContactsModule,
    GenesysCloudDesktopNotificationsModule,
    GenesysCloudWorkItemIntegrationsModule,
    GenesysCloudRoutingStatusModule,
    GenesysCloudIntegrationsModule,
    GenesysCloudCobrowseModule,
    GenesysCloudFeatureTogglesModule
  ]
})
export class GenesysCloudStoreModule {
}
